import { render, staticRenderFns } from "./CreateAPReactWrapper.vue?vue&type=template&id=e6f9e822"
import script from "./CreateAPReactWrapper.vue?vue&type=script&lang=js"
export * from "./CreateAPReactWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports